import { format } from "date-fns";

import { resolveDefaultDate } from "../date/dateDefaults";
import type { DateDefaultContext } from "../date/dateDefaults";

interface DateValue {
  date: string;
  include_time: boolean;
}

interface DateRangeFormValue {
  from_date: DateValue;
  to_date: DateValue;
}

export const normalizeDateRangeDefaultValue = (
  value: string | DateRangeFormValue,
  { timezone }: DateDefaultContext
): DateRangeFormValue | undefined => {
  if (typeof value === "string") {
    const resolved = resolveDefaultDate(value, timezone);
    if (!resolved) return undefined;

    // A single default value fills both boundaries so the field renders (and edits)
    // as a range from=to, not a half-empty range showing only an end date.
    // The control pins a date-only boundary to UTC midnight, so it is stored as a calendar day.
    const date = format(resolved, "yyyy-MM-dd");
    return {
      from_date: { date, include_time: false },
      to_date: { date, include_time: false },
    };
  }
  return value;
};
